import React from "react";

export default function Three({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M168.32,241.24l-16.95-12.73a2.31,2.31,0,0,0-2.74,0l-16.95,12.73H46v47.89a9.17,9.17,0,0,0,9.18,9.17h189.7a9.13,9.13,0,0,0,9.18-9.17V241.24Z" />
      {children}
    </svg>
  );
}
